export const tabNameToPath = {
  enquiries: "enquiry",
  quotations: "quotation",
  order_acknowledgments: "order-acknowledgment",
  purchase_orders: "purchase-order",
  proforma_invoices: "proforma-invoice",
  packing_lists: "packing-list",
  invoices: "invoice",
  line_items: "line-item",
  vendor_invoices: "vendor-invoice",
};

export const pathToTabName = {
  enquiry: "enquiries",
  quotation: "quotations",
  "purchase-order": "purchase_orders",
  "order-acknowledgment": "order_acknowledgments",
  "proforma-invoice": "proforma_invoices",
  "packing-list": "packing_lists",
  invoice: "invoices",
  "trade-case": "trade_cases",
  "line-item": "line_items",
  "vendor-invoice": "vendor_invoices",
  "vendor-invoice-payments": "vendor_invoices_payments",
};

export const tabNames = [
  "enquiry",
  "quotation",
  "purchase-order",
  "order-acknowledgment",
  "packing-list",
  "proforma-invoice",
  "invoice",
];

export const numberWithCommas = (x) => {
  return x && !isNaN(x)
    ? x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    : "0";
};
